var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1007_2122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0C24.0666 0 18.2664 1.75947 13.3329 5.05591C8.39943 8.35235 4.55426 13.0377 2.28363 18.5195C0.0129986 24.0013 -0.581102 30.0333 0.576455 35.8527C1.73401 41.6721 4.59123 47.0176 8.78681 51.2132C12.9824 55.4088 18.3279 58.266 24.1473 59.4236C29.9667 60.5811 35.9987 59.987 41.4805 57.7164C46.9623 55.4458 51.6477 51.6006 54.9441 46.6671C58.2405 41.7336 60 35.9334 60 30C59.9914 22.0461 56.8279 14.4205 51.2037 8.7963C45.5795 3.17207 37.9539 0.0086027 30 0ZM30 55C25.0555 55 20.222 53.5338 16.1108 50.7867C11.9995 48.0397 8.79522 44.1352 6.90303 39.5671C5.01083 34.9989 4.51575 29.9723 5.48038 25.1227C6.44501 20.2732 8.82603 15.8186 12.3223 12.3223C15.8187 8.82602 20.2732 6.445 25.1228 5.48037C29.9723 4.51574 34.9989 5.01082 39.5671 6.90301C44.1353 8.7952 48.0397 11.9995 50.7868 16.1107C53.5338 20.222 55 25.0555 55 30C54.9927 36.6282 52.3565 42.9828 47.6696 47.6696C42.9828 52.3565 36.6282 54.9927 30 55Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 12.5C29.337 12.5 28.7011 12.7634 28.2322 13.2322C27.7634 13.7011 27.5 14.337 27.5 15V35C27.5 35.663 27.7634 36.2989 28.2322 36.7678C28.7011 37.2366 29.337 37.5 30 37.5C30.663 37.5 31.2989 37.2366 31.7678 36.7678C32.2366 36.2989 32.5 35.663 32.5 35V15C32.5 14.337 32.2366 13.7011 31.7678 13.2322C31.2989 12.7634 30.663 12.5 30 12.5Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 45C32.5 43.6193 31.3807 42.5 30 42.5C28.6193 42.5 27.5 43.6193 27.5 45C27.5 46.3807 28.6193 47.5 30 47.5C31.3807 47.5 32.5 46.3807 32.5 45Z",
    fill: "#FF6666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1007_2122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.a26bd98d9da286ebbc0978965e642983.svg";
export { ForwardRef as ReactComponent };